import { render } from "./Footer.vue?vue&type=template&id=198874de&scoped=true"
import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=198874de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198874de"],['__file',"src/components/layouts/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "198874de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('198874de', __exports__)) {
    api.reload('198874de', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=198874de&scoped=true", () => {
    api.rerender('198874de', render)
  })

}


export default __exports__